import React, { useState } from "react";
import styles from "./style.module.scss";
import appStyles from "../../../Application.module.scss";
import ButtonIcon from "../../../../../components/ButtonIcon/ButtonIcon";
import HeadingWithLine from "../../../../../components/HeadingWithLine/HeadingWithLine";
import useCommonStore from "../../../../../stores/common";
import { useMediaQuery } from "../../../../../hooks/useMediaQuery";
import {
  formatCurrency,
  formatNumberWithSpaces,
} from "../../../../../../components/helper/helper";
import CrossIconRed from "../../../../../assets/svg/icons/common/CrossIconRed";
import CheckMarkGreen from "../../../../../assets/svg/icons/common/CheckMarkGreen";
import CaretRight24 from "../../../../../assets/svg/icons/common/CaretRight24";

const renderYesNo = (value) => {
  if (value !== "" && value !== undefined && value !== null) {
    return value === "yes" ? (
      <>
        <CheckMarkGreen /> Yes
      </>
    ) : (
      <>
        <CrossIconRed /> No
      </>
    );
  } else {
    return "-";
  }
};

const getPricingDataById = (id, appData) => {
  let pricing = appData.prices.find((price) => price.id === id);
  return pricing ? pricing.pivot : { dollars: 0, percent: 0 };
};

function PinDebit({ appData }) {
  return (
    <>
      <div>
        <HeadingWithLine text="PIN DEBIT" />
        <ul>
          <li>
            <div>
              <p>Pin Debit</p>
              <p>{renderYesNo(appData.debit_pin)}</p>
            </div>
          </li>
          <li>
            <div>
              <p></p>
              <p></p>
            </div>
          </li>
          <li>
            <div>
              <p>Pin Debit rate</p>
              <p>{getPricingDataById(5, appData)?.percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Pin Debit Txn</p>
              <p>
                ${" "}
                {getPricingDataById(5, appData)?.dollars
                  ? formatCurrency(getPricingDataById(5, appData)?.dollars)
                  : 0}
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>Signature Debit Rate</p>
              <p>{getPricingDataById(6, appData)?.percent}%</p>
            </div>
          </li>

          <li>
            <div>
              <p>Signature Debit Txn</p>
              <p>
                ${" "}
                {getPricingDataById(6, appData)?.dollars
                  ? formatCurrency(getPricingDataById(6, appData)?.dollars)
                  : 0}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}

function GeneralFees({ appData }) {
  return (
    <>
      <div>
        <HeadingWithLine text="General fees" />
        <ul>
          <li>
            <div>
              <p>Service (Monthly)</p>
              <p>
                ${" "}
                {getPricingDataById(17, appData)?.dollars
                  ? formatCurrency(getPricingDataById(17, appData)?.dollars)
                  : 0}
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>Authorization (Per Item)</p>
              <p>
                ${" "}
                {getPricingDataById(11, appData)?.dollars
                  ? formatCurrency(getPricingDataById(11, appData)?.dollars)
                  : 0}
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>Batch Header (Per Batch)</p>
              <p>
                ${" "}
                {getPricingDataById(14, appData)?.dollars
                  ? formatCurrency(getPricingDataById(14, appData)?.dollars)
                  : 0}
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>Voice Authorization (Per Item)</p>
              <p>
                ${" "}
                {getPricingDataById(12, appData)?.dollars
                  ? formatCurrency(getPricingDataById(12, appData)?.dollars)
                  : 0}
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>Chargeback (Per Item)</p>
              <p>
                ${" "}
                {getPricingDataById(20, appData)?.dollars
                  ? formatCurrency(getPricingDataById(20, appData)?.dollars)
                  : 0}
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>Retrieval (Per Item)</p>
              <p>
                ${" "}
                {getPricingDataById(21, appData)?.dollars
                  ? formatCurrency(getPricingDataById(21, appData)?.dollars)
                  : 0}
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>NSF/ACH Reject (Per Item)</p>
              <p>
                ${" "}
                {getPricingDataById(22, appData)?.dollars
                  ? formatCurrency(getPricingDataById(22, appData)?.dollars)
                  : 0}
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>Monthly Minimum (minimum discount)</p>
              <p>
                ${" "}
                {getPricingDataById(18, appData)?.dollars
                  ? formatCurrency(getPricingDataById(18, appData)?.dollars)
                  : 0}
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>Annual Fee</p>
              <p>
                ${" "}
                {getPricingDataById(25, appData)?.dollars
                  ? formatCurrency(getPricingDataById(25, appData)?.dollars)
                  : 0}
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>Early closure (ETF)</p>
              <p>
                ${" "}
                {getPricingDataById(27, appData)?.dollars
                  ? formatCurrency(getPricingDataById(27, appData)?.dollars)
                  : 0}
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>AVS Fee</p>
              <p>
                ${" "}
                {getPricingDataById(13, appData)?.dollars
                  ? formatCurrency(getPricingDataById(13, appData)?.dollars)
                  : 0}
              </p>
            </div>
          </li>
        </ul>
      </div>

      <div>
        <HeadingWithLine text="EBT Fees" />
        <ul>
          <li>
            <div>
              <p>Does Merchant Accept EBT</p>
              <p>{appData.ebt_fees}</p>
            </div>
          </li>
          <li>
            <div>
              <p></p>
              <p></p>
            </div>
          </li>
          {appData.ebt_fees === "yes" && (
            <>
              <li>
                <div>
                  <p>EBT Transactions (Per Item)</p>
                  <p>
                    ${" "}
                    {getPricingDataById(29, appData).dollars
                      ? formatCurrency(getPricingDataById(29, appData).dollars)
                      : 0}
                  </p>
                </div>
              </li>
              <li>
                <div>
                  <p>EBT Transaction (Monthly)</p>
                  <p>
                    ${" "}
                    {getPricingDataById(30, appData).dollars
                      ? formatCurrency(getPricingDataById(30, appData).dollars)
                      : 0}
                  </p>
                </div>
              </li>
              <li>
                <div>
                  <p>EBT Reg Number</p>
                  <p>
                    {getPricingDataById(31, appData).dollars
                      ? formatNumberWithSpaces(
                          getPricingDataById(31, appData).dollars,
                        )
                      : 0}
                  </p>
                </div>
              </li>
            </>
          )}
        </ul>
      </div>
    </>
  );
}

function TieredPricing({ appData }) {
  return (
    <>
      <div>
        <HeadingWithLine text="Processing Fees" />
        <ul>
          <li>
            <div>
              <p>Qual Rate</p>
              <p>{getPricingDataById(1, appData).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Qual Txn Fee</p>
              <p>
                ${" "}
                {getPricingDataById(1, appData).dollars
                  ? formatCurrency(getPricingDataById(1, appData).dollars)
                  : 0}
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>Mid Qual Rate</p>
              <p>{getPricingDataById(3, appData).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Mod Qual Txn Fee</p>
              <p>
                ${" "}
                {getPricingDataById(3, appData).dollars
                  ? formatCurrency(getPricingDataById(3, appData).dollars)
                  : 0}
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>Non Qual Rate</p>
              <p>{getPricingDataById(4, appData).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p> Non Qual Txn Fee</p>
              <p>
                ${" "}
                {getPricingDataById(4, appData).dollars
                  ? formatCurrency(getPricingDataById(4, appData).dollars)
                  : 0}
              </p>
            </div>
          </li>
        </ul>
      </div>

      <PinDebit appData={appData} />

      <GeneralFees appData={appData} />

      <div>
        <HeadingWithLine text="American Express" />
        <ul>
          <li>
            <div>
              <p>Does Merchant want to accept American Express?</p>
              <p>{appData?.apexoptout == "yes" ? "No" : "Yes"}</p>
            </div>
          </li>
          <li>
            <div>
              <p></p>
              <p></p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Tier 1 (<$150)"}</p>
              <p>
                {getPricingDataById(32, appData).percent
                  ? formatCurrency(getPricingDataById(32, appData).percent)
                  : 0}
                %
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Tier 1 (<$150)"}</p>
              <p>
                ${" "}
                {getPricingDataById(32, appData).dollars
                  ? formatCurrency(getPricingDataById(32, appData).dollars)
                  : 0}
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Tier 2 ($150 - $3,000)"}</p>
              <p>
                {getPricingDataById(33, appData).percent
                  ? formatCurrency(getPricingDataById(33, appData).percent)
                  : 0}
                %
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Tier 2 ($150 - $3,000)"}</p>
              <p>
                ${" "}
                {getPricingDataById(33, appData).dollars
                  ? formatCurrency(getPricingDataById(33, appData).dollars)
                  : 0}
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Tier 3 (>$3,000)"}</p>
              <p>
                {getPricingDataById(34, appData).percent
                  ? formatCurrency(getPricingDataById(34, appData).percent)
                  : 0}
                %
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Tier 3 (>$3,000)"}</p>
              <p>
                ${" "}
                {getPricingDataById(34, appData).dollars
                  ? formatCurrency(getPricingDataById(34, appData).dollars)
                  : 0}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}

function ICPlus({ appData }) {
  return (
    <>
      <div>
        <HeadingWithLine text="Processing Fees" />
        <ul>
          <li>
            <div>
              <p>Passthrough (per item)</p>
              <p>{getPricingDataById(2, appData).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Passthrough (per item) Txn</p>
              <p>
                ${" "}
                {getPricingDataById(2, appData).dollars
                  ? formatCurrency(getPricingDataById(2, appData).dollars)
                  : 0}
              </p>
            </div>
          </li>
        </ul>
      </div>

      <PinDebit appData={appData} />

      <GeneralFees appData={appData} />

      <div>
        <HeadingWithLine text="American Express" />
        <ul>
          <li>
            <div>
              <p>Does Merchant want to accept American Express?</p>
              <p>{appData?.apexoptout == "yes" ? "No" : "Yes"}</p>
            </div>
          </li>
          <li>
            <div>
              <p></p>
              <p></p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Passthrough (Per Item) Rate"}</p>
              <p>{getPricingDataById(35, appData).percent} %</p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Passthrough (Per Item) Txn"}</p>
              <p>
                ${" "}
                {getPricingDataById(35, appData).dollars
                  ? formatCurrency(getPricingDataById(35, appData).dollars)
                  : 0}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}

function Surcharge({ appData }) {
  return (
    <>
      <div>
        <HeadingWithLine text="Processing Fees" />
        <ul>
          <li>
            <div>
              <p>Passthrough (per item)</p>
              <p>{getPricingDataById(35, appData).percent}%</p>
            </div>
          </li>
        </ul>
      </div>

      <GeneralFees appData={appData} />
    </>
  );
}

function FlatRate({ appData }) {
  return (
    <>
      <div>
        <HeadingWithLine text="Processing Fees" />
        <ul>
          <li>
            <div>
              <p>Passthrough (per item)</p>
              <p>{getPricingDataById(2, appData).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Passthrough (per item) Txn</p>
              <p>
                ${" "}
                {getPricingDataById(2, appData).dollars
                  ? formatCurrency(getPricingDataById(2, appData).dollars)
                  : 0}
              </p>
            </div>
          </li>
        </ul>
      </div>

      <PinDebit appData={appData} />

      <GeneralFees appData={appData} />

      <div>
        <HeadingWithLine text="American Express" />
        <ul>
          <li>
            <div>
              <p>Does Merchant want to accept American Express?</p>
              <p>{appData?.apexoptout == "yes" ? "No" : "Yes"}</p>
            </div>
          </li>
          <li>
            <div>
              <p></p>
              <p></p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Passthrough (Per Item) Rate"}</p>
              <p>{getPricingDataById(35, appData).percent} %</p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Passthrough (Per Item) Txn"}</p>
              <p>
                ${" "}
                {getPricingDataById(35, appData).dollars
                  ? formatCurrency(getPricingDataById(35, appData).dollars)
                  : 0}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}

function PartnerPricing({ appData }) {
  const expandAppDetails = useCommonStore((state) => state.expandDetails);
  const [expanded, setExpanded] = useState(false);
  const isMobile = useMediaQuery(768);
  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const renderPricing = (appData) => {
    if (appData.qualifiedtype == "tiered")
      return <TieredPricing appData={appData} />;
    if (appData.qualifiedtype == "icppt") return <ICPlus appData={appData} />;
    if (appData.qualifiedtype == "sccd") return <Surcharge appData={appData} />;
    if (appData.qualifiedtype == "frate") return <FlatRate appData={appData} />;
  };

  const getPricingName = (qualifiedtype) => {
    if (qualifiedtype === "tiered") return "Tiered";
    if (qualifiedtype === "sccd") return "Surcharge / Cash Discount";
    if (qualifiedtype === "frate") return "Flat Rate";
    if (qualifiedtype === "icppt") return "IC Plus / Pass Through";
  };

  return (
    <div
      className={`${isMobile ? appStyles.mobile_business_info : styles.pricing} ${expandAppDetails ? styles.expanded : ""}`}
    >
      <div className={isMobile ? appStyles.business_info_header : styles.head} onClick={toggleExpanded}>
        {isMobile ? (
          <>
            <CaretRight24 className={`${appStyles.caret_icon} ${expanded ? appStyles.expanded : ""}`} />
            <h4>Pricing</h4>
          </>
        ) : (
          <>
            <ButtonIcon>
              <CaretRight24 className={expanded ? styles.expanded : ""} />
            </ButtonIcon>
            <h5>Pricing</h5>
          </>
        )}
      </div>

      <div
        className={`${isMobile ? appStyles.mobile_content : styles.body} ${expanded ? (isMobile ? appStyles.expanded : styles.body_expanded) : ""} ${expandAppDetails ? styles.app_details_expanded : ""}`}
      >
        {expanded && (
          <>
            <ul>
              <li>
                <div>
                  <p>Pricing model</p>
                  <p>{getPricingName(appData.qualifiedtype)}</p>
                </div>
              </li>
            </ul>
            {renderPricing(appData)}
          </>
        )}
      </div>
    </div>
  );
}

export default PartnerPricing;
